import ListaEvento from './ListaEvento'

export default ListaEvento